module.exports = __webpack_public_path__ + "img/ezfire-logo.42dfffcd.png";